import auth from '@udacity/ureact-hoth';

import { logger } from '~/features/logging/logger';
import { getPdPromotionState } from '~/features/promotions/controllers/get-pd-promotion-state';

import { DiscountError } from '../errors';
import { Coupon, couponSchema } from '../models/coupon-code';

export async function postPersonalizedDiscountFlatForm(formData: {
  email: string;
  phoneNumber?: string;
}): Promise<Coupon> {
  const pdPromoState = await getPdPromotionState();

  if (pdPromoState.status === 'inactive') {
    logger.fatal('Error submitting form', {
      file: 'src/features/discount/controllers/post-personalized-discount-flat-form.ts',
      function: 'postPersonalizedDiscountFlatForm',
      pdPromoState,
    });
    throw new DiscountError({
      name: 'POST_FORM_ERROR',
      message: `Personal Discount promotion is not active.`,
    });
  }

  const url = '/api/post-discount-flat';
  const jwt = auth.getJWT();

  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', authorization: `Bearer ${jwt}` },
    body: JSON.stringify({ ...formData, promotionId: pdPromoState.promotionId }),
  });

  const data = await response.json().catch(() => {});

  if (!response.ok) {
    logger.fatal('Error submitting form', {
      file: 'src/features/discount/controllers/post-personalized-discount-flat-form.ts',
      function: 'postPersonalizedDiscountFlatForm',
      statusCode: response.status,
      error: data,
    });

    throw new DiscountError({
      name: 'POST_FORM_ERROR',
      message: `Error submitting form to url: ${url} with data: ${data}`,
    });
  }

  try {
    return couponSchema.parse(data);
  } catch (error) {
    logger.fatal('Error parsing coupon data', {
      file: 'src/features/discount/controllers/post-personalized-discount-flat-form.ts',
      function: 'postPersonalizedDiscountFlatForm',
      error: error,
    });

    throw new DiscountError({
      name: 'PARSE_COUPON_ERROR',
      message: `Error parsing coupon data: ${data}`,
    });
  }
}
